import {useTranslation} from "react-i18next";
import {setTrack} from "utils";
import {Fragment, useEffect} from "react";
import {Logo} from "parts";
import {Back} from "./Back";

export function Steps({index, force, onBack}) {
  const
    {t} = useTranslation(),
    steps = t('steps', {ns: 'survey', returnObjects: true})

  let step, stepCount = 0, count = 0

  for (const item of steps)
    count += item.count

  useEffect(() => {
    let count = 0

    for (const [i, item] of steps.entries()) {
      count += item.count

      if (index === count - 1)
        setTrack(`section_${i + 1}_completed`)
    }
  }, [index])

  if (index >= count || force)
    return

  return (
    <>
      <div className={'row xs mb-4'}>
        {
          steps.map((item, i) => {
            stepCount += item.count

            let percent = 100

            if (!step) {
              if (index < stepCount) {
                step = item

                if (index + 1 < stepCount)
                  percent = 100 - Math.round((stepCount - index - 1) / (item.count / 100))
              }
            } else if (step)
              percent = 0

            return (
              <div key={i} className={'progress md animate'}>
                <div style={{width: percent + '%'}}></div>
              </div>
            )
          })
        }
      </div>

      <div className={'row wide'} style={{order: -1}}>
        {
          onBack
            ? <Back onClick={onBack}/>
            : <i style={{width: 32}}/>
        }
        <Logo/>
        <div className={'small-sm marked'}>{step?.title}</div>
      </div>
    </>
  )
}